import { getProperty, isValid } from '../utils';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case 'ARTICLE_FETCHED':
      const pageData = action.payload.data;
      const { pageType } = pageData;

      let article = null;
      // properties that are common across various article types
      const baseArticleTracker = {
        construct: 'standard', // can be FBIA or Standard. where do we pull this from?
        InternalExperiment1: null, // what field handles this?
        sponsorship: 'normal',
        // omitting for now:
        // device
      };

      let standardArticleTracker = {};

      // regular article
      if (pageType.includes('article')) {
        article = pageData.article[0];
        const tags = isValid(article.tags) ? getProperty(article, ['tags']).toString() : "";

        standardArticleTracker = {
          author: getProperty(article, ['author', 'name']),
          pwCategory: getProperty(article, ['category']),
          publishDate: getProperty(article, ['publishData', 'date']),
          articleType: getProperty(article, ['sponsorship', 'articleType']), // Normal, Affiliate, Sponsored
          advertiser: getProperty(article, ['advertiser']), // there is no advertiser property in the endpoint. this needs to be updated.
          articleID: getProperty(article, ['id']),
          articleName: getProperty(article, ['headline']),
          tags: tags,
        };
      }

      return {
        ...baseArticleTracker,
        ...standardArticleTracker,
      };
      break;
    case 'LANDER_FETCHED':
    case 'CORPORATE_FETCHED':
    case 'NotFound':
      return {};
    default:
      return state;
  }
};
